class PublicQueryKeys {
  private prefix = 'public';

  getServiceInfos() {
    return [this.prefix, 'service', 'infos'];
  }

  getConfiguration() {
    return [this.prefix, 'configuration'];
  }

  getMailUnsubscribeInfo(token: string) {
    return [this.prefix, 'mail', 'unsubscribe', 'info', token];
  }
}

export default PublicQueryKeys;
